import { madridToday } from './madrid-date';

function pickDate(raw: string | undefined | null): string {
  if (!raw) return '';
  return String(raw).slice(0, 10);
}

type VacationFields = {
  vacation_starts_at?: string | undefined;
  vacation_ends_at?: string | undefined;
};

export function getVacationDates(member: VacationFields): {
  from: string;
  to: string;
} {
  return {
    from: pickDate(member.vacation_starts_at),
    to: pickDate(member.vacation_ends_at),
  };
}

export function isOnVacation(
  member: VacationFields,
  today: string = madridToday()
): boolean {
  const { from, to } = getVacationDates(member);
  if (!from || !to) return false;
  return today >= from && today <= to;
}

export function formatVacationRange(from: string, to: string): string {
  const fmt = (d: string): string => {
    const [, m, day] = d.split('-');
    return `${day}/${m}`;
  };
  return `${fmt(from)} - ${fmt(to)}`;
}
